'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const uuid = require('uuid');
import { Row } from 'react-bootstrap';

const Strings =              require('../../../../../app/shared/Strings');

import VoiceStore from '../../../stores/VoiceStore';
import VoiceActions from '../../../actions/VoiceActions';

class VoiceOptions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: VoiceStore.getState().options,
        };
    }
    
    setVolume=(e)=>{
        let volume = Number(e.target.value);
        if ((volume >=0 ) && (volume < 100)) {
            let options = {...this.state.options, volume };
            this.setState({options},()=>{
                this.updateVoiceOptions();
            });
        }
    }
    
    setEnabled=(e)=>{
        let disabled = !e.target.checked;
        let options = {...this.state.options, disabled };
        this.setState({options},()=>{
            this.updateVoiceOptions();
        });
    }
    
    updateVoiceOptions=()=>{
        VoiceActions.setVoiceOptions(uuid.v4(),this.state.options);
    }
    
    render() {
        let { volume, disabled } = this.state.options;
        return (
            <div className="voice-controls">
                <h2>Voice Controls
                    <span className="fa fa-close" onClick={this.props.onClose} aria-hidden />
                </h2>
                <div className="voice-controls-body">
                    <Row>
                        <input id="voice-enable-disable" type="checkbox" checked={!disabled} onChange={this.setEnabled}/>
                        <label htmlFor="voice-enable-disable">{Strings["en"].voice_options.VOICE_ENABLED}</label>
                    </Row>
                    <Row>
                        <label htmlFor="voice-volume">{Strings["en"].voice_options.VOLUME}</label>
                        <input id="voice-volume" type="range" value={volume} min={0} max={100} onChange={this.setVolume}/>
                    </Row>
                </div>
            </div>
        );
    }
};

VoiceOptions.propTypes = {
    onClose: PropTypes.func.isRequired,
};

module.exports = VoiceOptions;
